import { withDependencies } from '@wix/thunderbolt-ioc'
import type { CompRefAPI } from '@wix/thunderbolt-symbols'
import { CompRefAPISym } from '@wix/thunderbolt-symbols'
import type { CompRefTrait, TraitProvider } from '../types'

const compRefTraitFactory = (compRefAPI: CompRefAPI): TraitProvider<CompRefTrait> => {
	return (compId) => {
		return {
			getCompRef: () => compRefAPI.getCompRefById(compId),
		}
	}
}

export const CompRefTraitFactory = withDependencies([CompRefAPISym], compRefTraitFactory)
